function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m79.9996813 73.8731434v-67.74566765c0-2.77936393-1.8509301-5.12497958-4.386545-5.8749766l-2.8796761 1.72311814-31.9576851 34.07392671-1.0018711 3.1315501-.5853101 3.006238 9.9655853 37.2436016 1.5415563.5687478h23.1770952c3.3837365 0 6.1268506-2.7428016 6.1268506-6.1265381",
  fill: "#ea6618"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 6.12716325v67.74566765c0 2.0953041 1.05218331 3.9437343 2.65623942 5.0484174l1.96467967-.9406213 33.82674021-36.2167307 1.3262447-2.5828022.0496874-2.4968651-9.2062134-35.02579795-1.3946819-1.65811839h-23.09584551c-3.38373652 0-6.12685059 2.74311407-6.12685059 6.12685059",
  fill: "#d65813"
}), /*#__PURE__*/React.createElement("path", {
  d: "m39.773904 39.1814066 35.8392323-38.92921994c-.565048-.16738291-1.1512997-.25218666-1.7406181-.25218666h-44.6491971l10.5508954 39.1814066z",
  fill: "#e05e11"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.12685059 80h44.56919741l-10.922144-40.8189059-37.11797708 39.7404667c1.02043344.7039815 2.23121751 1.0801781 3.47092367 1.0784392",
  fill: "#de5c16"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31.7294055 32.2576535h3.5562358c1.4169944 5.3464787 3.0297379 10.03796 4.8289808 14.2711931 2.0379918-4.762481 3.5317359-9.4574623 4.7962309-14.2714431h3.3604866c-1.504994 5.9814762-3.9669842 12.0099521-6.782973 18.2324274h-2.9724882c-2.7049892-5.8964766-5.00748-11.9592024-6.7864729-18.2324274zm-11.7299533-9.2637131h7.9074685v33.9091149h-7.9424684v-2.6139896h4.8679806v-28.7508854h-4.8329807zm40.0420905 2.5442399h-4.8329808v28.7508854h4.8674806v2.6139896h-7.9422183v-33.9091149h7.9074685v2.5442399z",
  fill: "#fff"
}));

function SvgIconMobx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobx);
export default __webpack_public_path__ + "static/media/icon-mobx.e8804fcf.svg";
export { ForwardRef as ReactComponent };